var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFollow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 14,
    width: 15,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.45 6.1a2.7 2.7 0 1 0 0-5.4 2.7 2.7 0 0 0 0 5.4zM5.45 7.9a5.4 5.4 0 0 1 5.4 5.4H.05a5.4 5.4 0 0 1 5.4-5.4zM12.65 4.3a.9.9 0 1 0-1.8 0v.9h-.9a.9.9 0 1 0 0 1.8h.9v.9a.9.9 0 1 0 1.8 0V7h.9a.9.9 0 1 0 0-1.8h-.9z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFollow);
export default __webpack_public_path__ + "static/media/follow.0c05ac4781bd93a0ad61c69f847902a4.svg";
export { ForwardRef as ReactComponent };